var _defs, _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAndroidArabic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 207,
    height: 78,
    viewBox: "0 0 207 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.915,
    x2: -0.383,
    y1: 11.121,
    y2: 10.452,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.076,
    x2: -1.305,
    y1: 30.309,
    y2: 30.309,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.862,
    x2: -0.501,
    y1: 19.649,
    y2: 17.879,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.188,
    x2: 0.421,
    y1: 22.369,
    y2: 21.578,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.068,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .android-arabic-11{fill:#fff}.android-arabic-9{isolation:isolate;opacity:.12}.android-arabic-11{stroke:#fff;stroke-miterlimit:10;stroke-width:.2px}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2427",
    transform: "translate(.375 .214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2425"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_506",
    fill: "rgba(255,255,255,0)",
    d: "M0 0H207V78H0z",
    transform: "translate(-.375 -.214)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_507",
    width: 181,
    height: 54,
    stroke: "#a6a6a6",
    rx: 6,
    transform: "translate(12.625 11.786)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    fill: "#fff",
    d: "M30.479-23.208a5.559 5.559 0 0 0-5.661 5.64 5.573 5.573 0 0 0 5.661 5.64 5.573 5.573 0 0 0 5.661-5.64 5.559 5.559 0 0 0-5.661-5.64zm0 9.058a3.263 3.263 0 0 1-3.184-3.418 3.25 3.25 0 0 1 3.184-3.419 3.249 3.249 0 0 1 3.183 3.419 3.262 3.262 0 0 1-3.183 3.418zm-12.352-9.058a5.559 5.559 0 0 0-5.661 5.64 5.573 5.573 0 0 0 5.661 5.64 5.573 5.573 0 0 0 5.663-5.64 5.56 5.56 0 0 0-5.663-5.64zm0 9.058a3.263 3.263 0 0 1-3.183-3.418 3.25 3.25 0 0 1 3.183-3.419 3.25 3.25 0 0 1 3.184 3.419 3.263 3.263 0 0 1-3.184 3.418zM3.435-21.478v2.392H9.16a4.994 4.994 0 0 1-1.3 3.012 5.862 5.862 0 0 1-4.423 1.752 6.282 6.282 0 0 1-6.282-6.366 6.283 6.283 0 0 1 6.282-6.367 6.105 6.105 0 0 1 4.315 1.708l1.688-1.687a8.349 8.349 0 0 0-6-2.415 8.883 8.883 0 0 0-8.888 8.761 8.882 8.882 0 0 0 8.888 8.759 8.01 8.01 0 0 0 6.11-2.457 7.907 7.907 0 0 0 2.073-5.6 7.73 7.73 0 0 0-.129-1.495zm60.087 1.858a5.242 5.242 0 0 0-4.829-3.589 5.359 5.359 0 0 0-5.319 5.64 5.519 5.519 0 0 0 5.6 5.64 5.61 5.61 0 0 0 4.7-2.5l-1.925-1.281a3.223 3.223 0 0 1-2.778 1.56 2.87 2.87 0 0 1-2.735-1.708l7.542-3.121zm-7.692 1.881a3.094 3.094 0 0 1 2.948-3.29 2.182 2.182 0 0 1 2.094 1.2zM49.7-12.27h2.479v-16.58H49.7zm-4.059-9.679h-.085a3.909 3.909 0 0 0-2.969-1.26 5.609 5.609 0 0 0-5.406 5.661 5.585 5.585 0 0 0 5.406 5.619 3.843 3.843 0 0 0 2.969-1.282h.085v.812c0 2.159-1.152 3.313-3.012 3.313a3.122 3.122 0 0 1-2.842-2.009l-2.158.9a5.375 5.375 0 0 0 5 3.333c2.906 0 5.363-1.709 5.363-5.875v-10.13h-2.354zM42.8-14.15a3.236 3.236 0 0 1-3.14-3.4 3.262 3.262 0 0 1 3.14-3.44 3.178 3.178 0 0 1 3.012 3.44 3.151 3.151 0 0 1-3.012 3.4zm32.334-14.7H69.2v16.58h2.473v-6.281h3.456A5.254 5.254 0 0 0 80.57-23.7a5.253 5.253 0 0 0-5.439-5.149zm.064 7.99h-3.52v-5.683H75.2a2.872 2.872 0 0 1 2.9 2.843 2.888 2.888 0 0 1-2.9 2.842zm15.294-2.381a4.648 4.648 0 0 0-4.42 2.541l2.2.918A2.344 2.344 0 0 1 90.531-21a2.382 2.382 0 0 1 2.6 2.134v.17a5.474 5.474 0 0 0-2.581-.639c-2.367 0-4.778 1.3-4.778 3.732a3.831 3.831 0 0 0 4.116 3.648 3.492 3.492 0 0 0 3.158-1.622h.085v1.28h2.388v-6.356c.002-2.947-2.194-4.586-5.03-4.586zm-.3 9.086c-.812 0-1.942-.406-1.942-1.408 0-1.278 1.407-1.769 2.623-1.769a4.415 4.415 0 0 1 2.261.554 3 3 0 0 1-2.944 2.625zm14.034-8.724l-2.837 7.188h-.089l-2.944-7.188h-2.663l4.415 10.046-2.518 5.591h2.581l6.8-15.634zM81.935-12.27h2.475v-16.579h-2.475z",
    transform: "translate(73.49 64.425)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2424",
    transform: "translate(26.834 21.839)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    fill: "url(#linear-gradient)",
    d: "M-35.909-38.933a2.662 2.662 0 0 0-.613 1.863v29.33a2.659 2.659 0 0 0 .613 1.863l.1.1 16.43-16.43v-.393l-16.432-16.43z",
    transform: "translate(36.522 39.46)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    fill: "url(#linear-gradient-2)",
    d: "M-18.12-19.427l-5.48-5.478v-.387l5.478-5.478.123.07 6.489 3.688c1.853 1.053 1.853 2.776 0 3.829L-18-19.5z",
    transform: "translate(40.738 42.154)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    fill: "url(#linear-gradient-3)",
    d: "M-13.93-20.892l-5.6-5.6-16.53 16.526a2.156 2.156 0 0 0 2.756.081l19.374-11.007",
    transform: "translate(36.673 43.549)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    fill: "url(#linear-gradient-4)",
    d: "M-13.93-27.9L-33.3-38.908a2.156 2.156 0 0 0-2.756.081L-19.532-22.3z",
    transform: "translate(36.673 39.355)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2423",
    transform: "translate(0 22.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    d: "M-14.053-22.363L-33.3-11.426a2.208 2.208 0 0 1-2.656.015l-.1.1.1.1a2.206 2.206 0 0 0 2.656-.015l19.37-11.014z",
    transform: "translate(36.673 22.363)",
    style: {
      isolation: "isolate"
    },
    opacity: 0.2
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    d: "M-35.909-13.719a2.662 2.662 0 0 1-.613-1.863v.194a2.659 2.659 0 0 0 .613 1.863l.1-.1z",
    className: "android-arabic-9",
    transform: "translate(36.522 24.575)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    d: "M-12.854-24.773l-6.612 3.757.123.123 6.489-3.687a2.328 2.328 0 0 0 1.39-1.915 2.474 2.474 0 0 1-1.39 1.722z",
    className: "android-arabic-9",
    transform: "translate(42.085 43.549)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    fill: "#fff",
    d: "M-33.153-38.715L-7.29-24.02A2.471 2.471 0 0 1-5.9-22.3a2.327 2.327 0 0 0-1.39-1.915l-25.863-14.693c-1.853-1.053-3.369-.178-3.369 1.944v.194c0-2.122 1.516-2.998 3.369-1.945z",
    transform: "translate(36.522 39.355)",
    style: {
      isolation: "isolate"
    },
    opacity: 0.25
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2426",
    transform: "translate(104.364 18.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    d: "M24.582-29.8a2.587 2.587 0 0 1-1.946-.716 2.779 2.779 0 0 1-.7-2.026 5.418 5.418 0 0 1 .054-.794c.034-.248.113-.613.229-1.093l.536.129a4.362 4.362 0 0 0-.164 1.04 2.4 2.4 0 0 0 .534 1.663 1.9 1.9 0 0 0 1.488.6 4.867 4.867 0 0 0 2.159-.528 2.918 2.918 0 0 0 1.439-1.3 8.919 8.919 0 0 1-.955-2.785 1.172 1.172 0 0 1 .214-.684 2.372 2.372 0 0 1 .741-.619q.064.511.334 1.887l.008.057a2.351 2.351 0 0 0 1.062.243.106.106 0 0 1 .119.121v.869a.106.106 0 0 1-.119.121 2.114 2.114 0 0 1-.883-.178l.02.42a2.953 2.953 0 0 1-.57 1.716 4.27 4.27 0 0 1-1.558 1.339 4.354 4.354 0 0 1-2.042.518zm1.162-7.97a7.49 7.49 0 0 1-.944 1.07 8.971 8.971 0 0 1-1.048-.948c.5-.5.837-.854 1.019-1.068a12.073 12.073 0 0 0 .973.949z",
    className: "android-arabic-11",
    transform: "translate(-21.939 43.401)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    d: "M27.811-33.65a.107.107 0 0 1-.121-.121v-.869a.107.107 0 0 1 .121-.121 1.589 1.589 0 0 0 .936-.268 2.14 2.14 0 0 0 .659-.816l.293-.584a5.477 5.477 0 0 1 1.1-1.688 1.719 1.719 0 0 1 1.18-.492 1.151 1.151 0 0 1 .85.52 4.031 4.031 0 0 1 .684 1.339 5.205 5.205 0 0 1 .26 1.581 1.982 1.982 0 0 1-.164.816 1.944 1.944 0 0 1-.576.7 7.866 7.866 0 0 1-1.863-.241 6.234 6.234 0 0 1-1.65-.627 2.1 2.1 0 0 1-.748.666 2.1 2.1 0 0 1-.961.205zm4.9-1.11a5.371 5.371 0 0 0-.342-1.732c-.208-.55-.416-.826-.619-.826a.909.909 0 0 0-.521.164 1.976 1.976 0 0 0-.484.505 10.245 10.245 0 0 0-.655 1.154 7 7 0 0 0 2.622.735z",
    className: "android-arabic-11",
    transform: "translate(-20.063 43.436)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    d: "M39.044-33.905a9.864 9.864 0 0 1-1.1-.139 4.5 4.5 0 0 1-.625-.192 5.1 5.1 0 0 1-.666-.317 2.366 2.366 0 0 1-.516-.37.5.5 0 0 1-.175-.328 2.1 2.1 0 0 1 .2-.663 6.676 6.676 0 0 1 .324-.691 3.253 3.253 0 0 1 .965-.936 7.566 7.566 0 0 1 1.578-.866l-.05-.4a5.693 5.693 0 0 1 1.061-.761l.137 4.736a2.955 2.955 0 0 0 1.516.386.107.107 0 0 1 .122.121v.869a.107.107 0 0 1-.122.121 2.737 2.737 0 0 1-1.431-.332 1.255 1.255 0 0 1-.633-.936l-.052-.306zm-2.365-2.024a3.028 3.028 0 0 0 1.3.663 7.6 7.6 0 0 0 1.574.178l-.377-2.35-.008-.029a5.269 5.269 0 0 0-2.489 1.538z",
    className: "android-arabic-11",
    transform: "translate(-17.363 43.122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    d: "M44.265-37.372a.6.6 0 0 1 .358.114c-.176.423-.33.777-.464 1.062a4.043 4.043 0 0 1-.241.477 3.571 3.571 0 0 0 .915.434 3.332 3.332 0 0 0 .922.122.107.107 0 0 1 .122.121v.869a.107.107 0 0 1-.122.121 3.368 3.368 0 0 1-2.308-.847l-.236.314a2.569 2.569 0 0 1-1.056.349 8.939 8.939 0 0 1-1.785.184.107.107 0 0 1-.122-.121v-.869a.107.107 0 0 1 .122-.121 12.5 12.5 0 0 0 1.534-.08 2.037 2.037 0 0 0 .896-.257 3.9 3.9 0 0 0 .765-1.162l.257-.469a.466.466 0 0 1 .443-.241zm-1.3 5.165a5.771 5.771 0 0 1-.862 1 7.652 7.652 0 0 1-.969-.89q.384-.356.94-.983.126.132.889.873zm2.2-.207a5.7 5.7 0 0 1-.877.989 7.232 7.232 0 0 1-.963-.89q.328-.3.94-.983c.086.098.386.39.899.885z",
    className: "android-arabic-11",
    transform: "translate(-15.967 43.838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    d: "M44.6-32.462a.107.107 0 0 1-.121-.121v-.869a.107.107 0 0 1 .121-.121 3.584 3.584 0 0 0 1.6-.378q-.193-1.54-.464-5.542l-.143-1.944a5.8 5.8 0 0 1 .985-.812q.092 2 .149 6.289l.05 2a2.953 2.953 0 0 0 1.517.386c.085 0 .127.04.127.121v.869c0 .081-.042.121-.127.121a2.485 2.485 0 0 1-1.675-.52 4.055 4.055 0 0 1-.961.41 4.251 4.251 0 0 1-1.058.111z",
    className: "android-arabic-11",
    transform: "translate(-14.587 42.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    d: "M47.439-33.527a.108.108 0 0 1-.122-.121v-.869a.108.108 0 0 1 .122-.121q.941 0 1.816-.044a2.131 2.131 0 0 1-.609-.626 1.535 1.535 0 0 1-.259-.849 2.938 2.938 0 0 1 .338-1.3 3.175 3.175 0 0 1 .871-1.1 1.793 1.793 0 0 1 1.119-.42 1.992 1.992 0 0 1 .968.253 6.36 6.36 0 0 1 1.076.786l-.256.463a6.827 6.827 0 0 0-.839-.277 2.722 2.722 0 0 0-.578-.057 3.893 3.893 0 0 0-1.873.534 2.21 2.21 0 0 0 .3 1.143 2.235 2.235 0 0 0 .879.83 3.192 3.192 0 0 0 1.361.355 10.236 10.236 0 0 0 1.061-.275q.507-.159 1.418-.516a.672.672 0 0 1 .2.52l-.015.15a.734.734 0 0 1-.606.619q-1.737.434-2.628.594c-.593.107-1.2.19-1.826.247s-1.263.081-1.918.081z",
    className: "android-arabic-11",
    transform: "translate(-13.661 43.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    d: "M62.377-31.67l-.37-2.358q-.619-3.7-.816-5.162A18.526 18.526 0 0 1 61-41.109a1.141 1.141 0 0 1 .228-.763 1.254 1.254 0 0 1 .725-.377c.015.061.028.118.044.17s.172.573.476 1.561l-.342.3.029.228.476 4.323q.129.947.194 1.817l.007.029a2.25 2.25 0 0 0 1.069.249.106.106 0 0 1 .121.121v.869a.106.106 0 0 1-.121.121 2.206 2.206 0 0 1-1-.235l.013.477a3 3 0 0 1-.562 1.724 4.22 4.22 0 0 1-1.546 1.335 4.319 4.319 0 0 1-2.029.516 2.584 2.584 0 0 1-1.944-.716 2.78 2.78 0 0 1-.7-2.026 5.418 5.418 0 0 1 .054-.794c.034-.248.113-.613.231-1.093l.534.129a4.431 4.431 0 0 0-.164 1.04 2.4 2.4 0 0 0 .534 1.663 1.9 1.9 0 0 0 1.488.6 4.666 4.666 0 0 0 1.44-.243 4.565 4.565 0 0 0 1.317-.663 2.467 2.467 0 0 0 .805-.923z",
    className: "android-arabic-11",
    transform: "translate(-10.784 42.248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    d: "M73.543-33.588a3.219 3.219 0 0 1-1.231-.249 2.869 2.869 0 0 1-1.005-.655 5.369 5.369 0 0 1-1.585.663 7.493 7.493 0 0 1-1.871.241 10.809 10.809 0 0 1-2.164-.227 6.366 6.366 0 0 1-1.766-.591l-.249.285a2.066 2.066 0 0 1-1.6.533.107.107 0 0 1-.122-.121v-.869a.107.107 0 0 1 .122-.121 1.972 1.972 0 0 0 1.04-.239 2.548 2.548 0 0 0 .776-.923l.228-.406a.5.5 0 0 1 .464-.256.463.463 0 0 1 .341.135q-.306.74-.435 1.011a5.27 5.27 0 0 0 .728.285q2.791-3.7 4.758-3.7a2.219 2.219 0 0 1 1.019.336 4.18 4.18 0 0 1 1.082.861 1.5 1.5 0 0 1 .476.927 2.421 2.421 0 0 1-.561 1.574 2.956 2.956 0 0 0 1.552.4c.086 0 .129.04.129.121v.869c.002.076-.04.116-.126.116zM68-34.7a7.343 7.343 0 0 0 3.9-1.247 3.594 3.594 0 0 0-1.061-1.2 2.135 2.135 0 0 0-1.224-.431 3.037 3.037 0 0 0-1.647.672 11.71 11.71 0 0 0-2.072 1.991A11.427 11.427 0 0 0 68-34.7z",
    className: "android-arabic-11",
    transform: "translate(-8.887 43.374)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    d: "M70.778-33.65a.108.108 0 0 1-.122-.121v-.869a.108.108 0 0 1 .122-.121 12.125 12.125 0 0 0 3.37-.371l.81-.277a8.416 8.416 0 0 1 1.469-.428 6.445 6.445 0 0 1-1.127-.725 6 6 0 0 0-.956-.645 1.671 1.671 0 0 0-.753-.182 2.273 2.273 0 0 0-1.253.355l-.338.215a.768.768 0 0 1-.212-.569 1.025 1.025 0 0 1 .484-.883 2.192 2.192 0 0 1 1.274-.336 2.381 2.381 0 0 1 .936.2 5.728 5.728 0 0 1 1.1.655 10.615 10.615 0 0 0 1.3.843 4.348 4.348 0 0 0 1.082.4 7.909 7.909 0 0 0 1.6.121L79-35.309c-.3-.038-.576-.064-.82-.078l-.049-.008-.3.008a3.063 3.063 0 0 0-.964.15 11.083 11.083 0 0 0-1.428.647 8.076 8.076 0 0 1-1.971.752 13.948 13.948 0 0 1-2.69.188z",
    className: "android-arabic-11",
    transform: "translate(-6.048 43.436)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    d: "M79.048-37.32v.912q0 1.41-.1 3.825l-.67.121q-.093-5.112-.4-8.49l-.007-.186a1.1 1.1 0 0 1 .231-.736 1.235 1.235 0 0 1 .731-.374c.013.061.028.118.042.17s.174.573.477 1.561l-.393.334.007.072c.055 1.043.082 1.976.082 2.791z",
    className: "android-arabic-11",
    transform: "translate(-3.694 42.248)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidArabic);
export default __webpack_public_path__ + "static/media/android-arabic.b6d67b74525e8695b568c3db1cdfa3bc.svg";
export { ForwardRef as ReactComponent };